import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from "./Container";
import styled from "@emotion/styled";
import { colors } from "./theme";
export function RTCTitle({ alignment = "left", contentColor = colors.black, linkColor = colors.blueMain, content = "", size = "medium", typography = "inherit", }) {
    let cleanedContent = "";
    if (content.indexOf("<p>") === -1) {
        cleanedContent = `<${titleElement[size]}>${content}</${titleElement[size]}>`;
    }
    else {
        cleanedContent = content.replace(/p>/gi, `${titleElement[size]}>`);
    }
    return (_jsx(ContainerStyled, { alignment: alignment, typography: typography, contentColor: contentColor, fontSize: fontSize[size], linkColor: linkColor, dangerouslySetInnerHTML: { __html: cleanedContent } }, void 0));
}
const ContainerStyled = styled(Container)(({ alignment, typography, contentColor, fontSize, linkColor }) => ({
    textAlign: alignment,
    wordBreak: "break-word",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "& > h1, h2, h3, h4": {
        fontFamily: typography,
        color: contentColor,
        fontSize: fontSize,
        margin: 0,
        "& a": {
            color: linkColor,
        },
    },
}));
const titleElement = {
    "very-big": "h1",
    big: "h2",
    medium: "h3",
    small: "h4",
};
const fontSize = {
    "very-big": "4.2rem",
    big: "3.6rem",
    medium: "3rem",
    small: "2.4rem",
};
//# sourceMappingURL=Title.js.map